import { ProtectedRoute } from "@app/protected-route";
import { Settings } from "@pages/settings/settings";
import { isPartnerSection, type PartnerSection } from "@pages/settings/types";
import { createFileRoute } from "@tanstack/react-router";
import {
	isSettingsView,
	type SettingsView,
} from "@widgets/settings-view-tabs/settings-view-tabs";

interface SearchParams {
	view: SettingsView;
	section: PartnerSection;
}

export const Route = createFileRoute("/_layout/settings/")({
	component: RouteComponent,
	validateSearch: (search: Record<string, unknown>): SearchParams => ({
		view: isSettingsView(search.view) ? search.view : "model",
		section: isPartnerSection(search.section) ? search.section : "partner",
	}),
});

function RouteComponent() {
	return (
		<ProtectedRoute
			requiredPermissions={[
				"root",
				"scoring_settings",
				"model_settings",
				"ocr_settings",
				// An approver may hold nothing but the right to decide on queued
				// changes; without this the queue would be unreachable for them.
				"approve_model_changes",
			]}
		>
			<Settings />
		</ProtectedRoute>
	);
}
